import React, {useEffect} from "react";
import {Col, Row} from "react-bootstrap";
import TextArea from "../../../common/TextArea";
import Input from "../../../common/Input";
import DateBox from "../../../primer/DateBox";
import {useDispatch, useSelector} from "react-redux";
import {setSaveNewBankAccounts} from "../../../../_reducers/activitySlice";
import Checkbox from "../../../common/CheckBox";
import {setNewBankAccount} from "../../../../_reducers/DataPanel/Cash/cashSlice";
import {banksDummyData} from "../../../../_data/dummy_banks";
import {getObjectFromArrayOfObjects} from "../../../../_helpers/helperFunctions";
import AdvancedCombobox from "../../../primer/AdvancedCombobox";
import {checkPermission, isEmpty} from "../../../../_helpers/commonFunctions";
import {fetchCashSettings} from "../../../../_apis/api";
import {useTranslation} from "../../../../hooks/useTranslation";

const BankAccountsNew = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const saveNewBankAccounts = useSelector((state) => state.ACTIVITY.saveNewBankAccounts);
    const newBankAccount = useSelector((state) => state.CASH_DATA.newBankAccount);
    const cashSettings = useSelector((state) => state.CASH_DATA.cashSettings);
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const permissionsData = JSON.parse(localStorage.getItem("user"))?.permissions;

    useEffect(() => {
        dispatch(fetchCashSettings(company.id));
    }, [])

    useEffect(() => {
        if (!isEmpty(cashSettings?.accounting?.accountingBankAccount) && isEmpty(newBankAccount.name)) {
            dispatch(setNewBankAccount({...newBankAccount, accounting: cashSettings.accounting.accountingBankAccount}))
        }
    }, [cashSettings.accounting])

    const handleOnChange = (e, type = "default", ddname = '') => {
        if (!saveNewBankAccounts) dispatch(setSaveNewBankAccounts(true));

        let name;
        let value;
        if (type === 'dd' || type === 'ac') {
            value = e.value;
            name = ddname;
        } else if (type === 'dp') {
            value = e;
            name = ddname;
        } else if (type === 'acdd') {
            e = e.row;
            value = e._id;
            name = ddname;
        } else {
            value = e.target.value;
            name = e.target.name;
        }
        const newBankAccountData = {};
        if (name === 'bank') {
            newBankAccountData[name] = value;
            const selectedBank = getObjectFromArrayOfObjects(banksDummyData, value, '_id');
            if (selectedBank.length > 0) {
                newBankAccountData['bankName'] = selectedBank['0'].name;
                newBankAccountData['bankSwift'] = selectedBank['0'].swift;
                newBankAccountData['bankCountry'] = selectedBank['0'].country;
            }
        } else {
            newBankAccountData[name] = value;
        }
        dispatch(setNewBankAccount({...newBankAccount, ...newBankAccountData}));
    }

    const bankColumns = [
        {
            label: t('BankAccountsNew.smallTable.name'),
            name: "name",
        },
        {
            label: t('BankAccountsNew.smallTable.swift'),
            name: "swift",
        },
        {
            label: t('BankAccountsNew.smallTable.country'),
            name: "country",
        },
    ]

    return (
        <React.Fragment>
            <Row className="position-relative border-bottom mb-3">
                <Col xs="12" md="12" className="d-flex align-items-center justify-content-end ">
                    <div className="inline-field d-flex align-items-center acremd  mb-3">
                        <label htmlFor="product-active" className="mb-0 mr-2 ">{t('BankAccountsNew.active')}</label>
                        <Checkbox
                            className="mb-2"
                            name="isActive"
                            key={Math.random()}
                            id="bank-active"
                            defaultValue={newBankAccount.isActive}
                            value={newBankAccount.isActive === 'active' ? "inactive" : "active"}
                            onChange={(e) => handleOnChange(e)}
                        />
                    </div>
                </Col>
            </Row>
            <Row>
                <Col sm="12" md="4">
                    <div className="mb-3">
                        <Input
                            className="w-100"
                            label={t('BankAccountsNew.name.name')}
                            name="name"
                            placeholder={t('BankAccountsNew.name.placeholder')}
                            value={newBankAccount.name}
                            required={true}
                            onChange={(e) => handleOnChange(e)}
                        />
                        {saveNewBankAccounts && newBankAccount.name === '' &&
                            <div className="text-danger">{t('BankAccountsNew.name.required')}</div>}
                    </div>
                </Col>
                <Col sm={12} md={4}>
                    <AdvancedCombobox
                        className="w-100 ac-select-dropdown"
                        defaultValue={newBankAccount.bankName}
                        key={Math.random()}
                        label={t('BankAccountsNew.bank.bank')}
                        data={banksDummyData}
                        onChange={(e) => handleOnChange(e, 'acdd', 'bank')}
                        excludeColumns={[]}
                        columns={bankColumns}
                        deleteEnable={false}
                        searchTableEnable={false}
                        showTableOptionOnSelect={true}
                        placeholder={t('BankAccountsNew.bank.placeholder')}
                    />
                </Col>
            </Row>
            <Row>
                <Col sm="12" md="4">
                    <div className="mb-3">
                        <DateBox
                            classes="w-100"
                            label={t('BankAccountsNew.date.date')}
                            name="date"
                            required={true}
                            allowOtherYears={true}
                            selected="today"
                            onChange={(e) => handleOnChange(e, 'dp', 'date')}
                        />
                        {saveNewBankAccounts && isEmpty(newBankAccount.date) &&
                            <div className="text-danger">{t('BankAccountsNew.date.required')}</div>}
                    </div>
                </Col>
            </Row>
            <Row>
                <Col sm="12" md="8">
                    <div className="mb-3">
                        <Input
                            className="w-100"
                            label={t('BankAccountsNew.iban.iban')}
                            name="iban"
                            placeholder={t('BankAccountsNew.iban.placeholder')}
                            value={newBankAccount.iban}
                            required={true}
                            onChange={(e) => handleOnChange(e)}
                        />
                        {saveNewBankAccounts && newBankAccount.iban === '' &&
                            <div className="text-danger">{t('BankAccountsNew.iban.required')} </div>}
                    </div>
                </Col>
            </Row>
            <hr className="mb-4"/>
            <Row>
                <div style={{width: "100%"}}>
                    <div className="text-muted mb-2"><i>{t('BankAccountsNew.notes')}</i></div>
                    <TextArea
                        rows="4"
                        placeholder={t('BankAccountsNew.addNotes')}
                        name="notes"
                        limit="1000"
                        value={newBankAccount.notes}
                        onChange={(e) => handleOnChange(e)}
                    />
                </div>
            </Row>
            {checkPermission("accounting-settings/accounting-read", permissionsData) === true && (
                <React.Fragment>
                    <hr/>
                    <div className="text-muted mb-2"><i>Λογιστική</i></div>
                    <Row className={"mb-2"}>
                        <Col md={4}>
                            <Input
                                name={"accounting"}
                                label={"Πρόθεμα Κωδικού Λογαριασμού"}
                                value={newBankAccount?.accounting}
                                onChange={(e) => handleOnChange(e)}
                            />
                        </Col>
                        <Col md={4}>
                            <Input
                                name={"bypassAccounting"}
                                label={"Κωδικός Λογαριασμού Παράκαμψης Λογιστικής Γέφυρας"}
                                value={newBankAccount?.bypassAccounting}
                                onChange={(e) => handleOnChange(e)}
                            />
                        </Col>
                        <Col md={4}>
                            <Input
                                name={"accountingRunning"}
                                label={"Λογιστικός λογαριασμός αντιστοιχίας Όψεως"}
                                value={newBankAccount?.accountingRunning}
                                onChange={(e) => handleOnChange(e)}
                            />
                        </Col>
                    </Row>
                </React.Fragment>
            )}
        </React.Fragment>
    )
}

export default BankAccountsNew;
